module.exports = __webpack_public_path__ + "img/22_5.549e44ae.png";